import { GetChooseRecipientAddressBookAddressProps } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

export const getChooseRecipientAddressBookAddressTag = (options: GetChooseRecipientAddressBookAddressProps) => {
  const level2 = 'Address the Envelope - Recipient';
  const modalEvent = [
    {
      eventInfo: {
        eventName: 'address book',
        eventAction: 'choose address',
      },
    },
  ];

  if (options.quantity) {
    modalEvent.push({
      eventInfo: {
        eventName: 'address book quantity selected',
        eventAction: options.quantity.toString(),
      },
    });
  }

  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const { modal, user } = getModalTag(options.productType, level2, modalEvent, options.projectID);

  const newModal = {
    ...modal,
    messages: [{ statusMessages: '' }],
  };

  return {
    modal: newModal,
    product,
    user,
  };
};
